import { render, staticRenderFns } from "./ingredientsEdit.vue?vue&type=template&id=5b99136c"
import script from "./ingredientsEdit.vue?vue&type=script&lang=js"
export * from "./ingredientsEdit.vue?vue&type=script&lang=js"
import style0 from "./ingredientsEdit.vue?vue&type=style&index=0&id=5b99136c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports